import makeStyles from '@material-ui/core/styles/makeStyles';
var useStyles = makeStyles({
    divider: {
        width: '100%',
        height: '1px',
        backgroundColor: '#8E8E8E',
    },
}, { name: 'Divider' });
export { useStyles };
